var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{attrs:{"to":"/unos-casa"}},[_c('feather-icon',{attrs:{"size":"21","icon":"FilePlusIcon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }